import { IQuotaAmount, QuotaUnits } from '../types/leave-policy'
import { IWorkingSchedule, WorkingHours } from '../types/work-week'
import { roundTo2Decimals, roundTo4Decimals } from './calculation-shared'
import { computeDaysAndHours } from './get-days-or-hours'
import { getAverageWorkingHours, userHasWorkingHoursSchedule } from './work-week'

export function getRawQuotaDaysOrHours(hourlyLeaveAccounting: boolean, quotaAmount: IQuotaAmount): number {
  return getDaysOrHoursBasedOnUnit({
    ...quotaAmount.raw,
    unit: hourlyLeaveAccounting ? 'hours' : 'days',
  })
}

export function getDaysOrHoursBasedOnUnit({ days, hours, unit }: { unit: QuotaUnits; days: number; hours: number }): number {
  return unit === 'hours' ? roundTo2Decimals(hours) : roundTo4Decimals(days)
}

export function formatQuotaInDaysOrHours(hourlyLeaveAccounting: boolean, value: number, workingHours: WorkingHours | IWorkingSchedule, showMinutes: boolean): IQuotaAmount {
  return hourlyLeaveAccounting ? formatQuotaInHours(value, workingHours, showMinutes) : formatQuota(value, getAverageWorkingHours(workingHours), showMinutes, workingHours)
}

export function formatQuota(valueInDays: number, averageWorkingHours: number, showMinutes: boolean, workingHours?: WorkingHours | IWorkingSchedule): IQuotaAmount {
  const hasSchedule = workingHours ? userHasWorkingHoursSchedule(workingHours) : false
  const result = computeDaysAndHours(valueInDays * averageWorkingHours, averageWorkingHours, showMinutes, hasSchedule)
  return {
    raw: {
      days: roundTo4Decimals(valueInDays),
      hours: roundTo2Decimals(valueInDays * averageWorkingHours),
    },
    days: result.days,
    hours: result.hours,
    minutes: result.minutes,
    isNegative: result.isNegative,
  }
}

function formatQuotaInHours(valueInHours: number, workWeek: WorkingHours | IWorkingSchedule, showMinutes: boolean): IQuotaAmount {
  // We take the average working hours in a week to calculate the number of days,
  // but we never calculate days if user has a working hours schedule
  const result = computeDaysAndHours(valueInHours, getAverageWorkingHours(workWeek), showMinutes, userHasWorkingHoursSchedule(workWeek))
  return {
    raw: {
      days: roundTo4Decimals(valueInHours / getAverageWorkingHours(workWeek)),
      hours: roundTo2Decimals(valueInHours),
    },
    days: result.days,
    hours: result.hours,
    minutes: result.minutes,
    isNegative: result.isNegative,
  }
}
